import { Box, Button, Divider, Typography } from "@mui/material";
import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link } from "react-router-dom";

const HelpCenter = () => {
  return (
    <Box sx={{ bgcolor: "#fff", p: 2 }}>
      <Box>
        <Typography sx={{ color: "#333", fontSize: "20px", fontWeight: 500 }}>
          Help Center
        </Typography>
        <Divider sx={{ mt: 3 }} />
        <Box
          sx={{
            bgcolor: "#EBDCEF",
            p: 2,
            mt: 1,
            borderRadius: "10px",
            display: "flex",
            flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" },
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography
              sx={{
                color: "#1a1a1a",
                fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                fontWeight: 600,
              }}
            >
              Still have questions?
            </Typography>
            <Typography sx={{ fontSize: "12px" }}>
              Can’t find the answer you’re looking for? Please chat to our
              friendly team.
            </Typography>
          </Box>
          <Link to="/contact">
            <Button variant="contained" sx={{ borderRadius: "20px" }}>
              Get in touch
            </Button>
          </Link>
        </Box>
        <Box sx={{ my: 3 }}>
          <Typography
            sx={{
              color: "#1a1a1a",
              fontSize: "24px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            FAQS
          </Typography>
        </Box>
        <Box>
          <Accordion
            defaultExpanded={true}
            sx={{
              mb: 2,
              border: "1px solid #E6E6E6",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                sx={{
                  color: "#333",
                  fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                  fontWeight: 500,
                }}
              >
                What is Mamaket?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Mamaket is an online marketplace where you can find products and
                services celebrating and connecting immigrant cultures. From
                traditional clothing to unique ingredients and specialized
                services, Mamaket helps you feel at home, wherever you are. See{" "}
                <b>About Us</b> for more information.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            defaultExpanded={true}
            sx={{
              mb: 2,
              border: "1px solid #E6E6E6",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                sx={{
                  color: "#333",
                  fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                  fontWeight: 500,
                }}
              >
                How does Mamaket work
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                <p>
                  Our easy-to-use platform allows you to browse, buy, and sell
                  directly. Sellers list their products and services for buyers
                  who can either <b>Buy Now, Add to Cart</b> or <b>Negotiate</b>{" "}
                  depending on the status of the product or service listing. We
                  handle all <b>payments</b> and <b>disputes</b> through our
                  in-house wallet system known as <b>Mamapurse</b> (see{" "}
                  <b>Mamapurse</b> for more information).
                </p>
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            defaultExpanded={true}
            sx={{
              mb: 2,
              border: "1px solid #E6E6E6",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                sx={{
                  color: "#333",
                  fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                  fontWeight: 500,
                }}
              >
                Who is Mamaket for?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Mamaket is for everyone! Whether you’re an immigrant looking for
                a taste of home, a cultural enthusiast, or someone seeking
                unique products, Mamaket is your destination. Sellers can also
                join to showcase their cultural crafts, food, or services.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            defaultExpanded={true}
            sx={{
              mb: 2,
              border: "1px solid #E6E6E6",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                sx={{
                  color: "#333",
                  fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                  fontWeight: 500,
                }}
              >
                Where is Mamaket available?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                We’re starting in South Florida, a vibrant hub for diverse
                immigrant communities. After our beta launch, we plan to expand
                to other cities across the United States and, eventually,
                globally.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            defaultExpanded={true}
            sx={{
              mb: 2,
              border: "1px solid #E6E6E6",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                sx={{
                  color: "#333",
                  fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                  fontWeight: 500,
                }}
              >
                What can I buy or sell on Mamaket?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                You can find a wide range of products and services, including:
                <ul>
                  <li>Traditional clothing</li>
                  <li>Specialty groceries and spices</li>
                  <li>Handmade crafts</li>
                  <li>Cultural artifacts</li>
                  <li>
                    Unique services like language lessons or event planning
                  </li>
                </ul>
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            defaultExpanded={true}
            sx={{
              mb: 2,
              border: "1px solid #E6E6E6",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                sx={{
                  color: "#333",
                  fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                  fontWeight: 500,
                }}
              >
                How do I become a seller on Mamaket?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Joining as a seller is easy! Sign up on our{" "}
                <a href="https://mamaket.com">platform</a>, create your shop,
                and start listing your products. We are always just a chat away
                to guide you through the process and provide tips to help you.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            defaultExpanded={true}
            sx={{
              mb: 2,
              border: "1px solid #E6E6E6",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                sx={{
                  color: "#333",
                  fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                  fontWeight: 500,
                }}
              >
                How does delivery work?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                We partner with trusted delivery services to ensure your
                products arrive quickly and safely. We work with services
                familiar with the community’s needs for local deliveries in
                South Florida.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            defaultExpanded={true}
            sx={{
              mb: 2,
              border: "1px solid #E6E6E6",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                sx={{
                  color: "#333",
                  fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                  fontWeight: 500,
                }}
              >
                How do payments work?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                We accept all major credit and debit cards through Mamapurse,
                our secure and reliable payment provider.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            defaultExpanded={true}
            sx={{
              mb: 2,
              border: "1px solid #E6E6E6",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                sx={{
                  color: "#333",
                  fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                  fontWeight: 500,
                }}
              >
                Is Mamaket safe to use?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Yes! We prioritize the safety of our users by offering secure
                payment options and maintaining strict seller verification
                processes. Our customer support team is here to help if you ever
                have concerns.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            defaultExpanded={true}
            sx={{
              mb: 2,
              border: "1px solid #E6E6E6",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                sx={{
                  color: "#333",
                  fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                  fontWeight: 500,
                }}
              >
                How does Mamaket support immigrant communities?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Mamaket is more than a marketplace—we’re a community. By
                connecting buyers and sellers from diverse backgrounds, we
                celebrate cultural heritage and empower small businesses to
                thrive. We also partner with local immigrant organizations to
                strengthen our impact.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            defaultExpanded={true}
            sx={{
              mb: 2,
              border: "1px solid #E6E6E6",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                sx={{
                  color: "#333",
                  fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                  fontWeight: 500,
                }}
              >
                How can I contact Mamaket for support?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                We’re here to help! Reach out to our support team via email or
                chat directly on our website. We’re committed to making your
                experience seamless and enjoyable.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            defaultExpanded={true}
            sx={{
              mb: 2,
              border: "1px solid #E6E6E6",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                sx={{
                  color: "#333",
                  fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                  fontWeight: 500,
                }}
              >
                What’s next for Mamaket?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                We’re excited to grow! Our next steps include expanding to more
                cities, introducing new features like multilingual support, and
                continuing to build partnerships that make cultural connection
                easier for everyone.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            defaultExpanded={true}
            sx={{
              mb: 2,
              border: "1px solid #E6E6E6",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                sx={{
                  color: "#333",
                  fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                  fontWeight: 500,
                }}
              >
                How can I get involved with Mamaket?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Join our platform as a buyer or seller, share your story, or
                partner with us to create a lasting impact. Follow us on social
                media and stay tuned for upcoming cultural events and
                initiatives.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            defaultExpanded={true}
            sx={{
              mb: 2,
              border: "1px solid #E6E6E6",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                sx={{
                  color: "#333",
                  fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                  fontWeight: 500,
                }}
              >
                Why should I choose Mamaket over other marketplace?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Mamaket is uniquely focused on celebrating immigrant cultures.
                We offer a curated experience that’s not just about
                shopping—it’s about connecting with your roots and discovering
                new traditions. Plus, we’re dedicated to supporting small
                businesses and promoting cultural diversity.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            defaultExpanded={true}
            sx={{
              mb: 2,
              border: "1px solid #E6E6E6",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                sx={{
                  color: "#333",
                  fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                  fontWeight: 500,
                }}
              >
                Is Mamaket only for immigrants?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Not at all! While we cater to immigrant communities, anyone can
                use Mamaket to explore and celebrate cultural diversity. It’s a
                place for everyone to connect and learn through unique products
                and stories.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            defaultExpanded={true}
            sx={{
              mb: 2,
              border: "1px solid #E6E6E6",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                sx={{
                  color: "#333",
                  fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                  fontWeight: 500,
                }}
              >
                How does Mamaket help promote my products?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Mamaket provides marketing support through featured listings,
                social media promotions, and search optimization to help your
                products reach the right audience.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            defaultExpanded={true}
            sx={{
              mb: 2,
              border: "1px solid #E6E6E6",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                sx={{
                  color: "#333",
                  fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                  fontWeight: 500,
                }}
              >
                How do I manage orders and track sales?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Our platform provides an intuitive dashboard where you can
                manage orders, track sales, and view analytics to help grow your
                business.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            defaultExpanded={true}
            sx={{
              mb: 2,
              border: "1px solid #E6E6E6",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                sx={{
                  color: "#333",
                  fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                  fontWeight: 500,
                }}
              >
                Can I sell services like catering or event planning on Mamaket?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Yes, Mamaket allows vendors to list services in addition to
                products, including catering, event planning, and other cultural
                services.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            defaultExpanded={true}
            sx={{
              mb: 2,
              border: "1px solid #E6E6E6",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                sx={{
                  color: "#333",
                  fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                  fontWeight: 500,
                }}
              >
                How do I get paid for my sales on Mamaket?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Payments are processed securely through our Mamapurse. You can
                track payment details in your vendor dashboard.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            defaultExpanded={true}
            sx={{
              mb: 2,
              border: "1px solid #E6E6E6",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                sx={{
                  color: "#333",
                  fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                  fontWeight: 500,
                }}
              >
                What happens if a buyer requests a return?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Mamaket has a clear return policy in place. Vendors will be
                notified of return requests, and we’ll work with both parties to
                resolve any issues fairly.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            defaultExpanded={true}
            sx={{
              mb: 2,
              border: "1px solid #E6E6E6",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                sx={{
                  color: "#333",
                  fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                  fontWeight: 500,
                }}
              >
                Does Mamaket offer any support to vendors?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Yes, we provide resources such as best practices for selling,
                tips for improving product listings, and customer support to
                ensure your success.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            defaultExpanded={true}
            sx={{
              mb: 2,
              border: "1px solid #E6E6E6",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                sx={{
                  color: "#333",
                  fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                  fontWeight: 500,
                }}
              >
                How can I improve my product listings to attract more buyers?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Use high-quality images, detailed descriptions, and competitive
                pricing. Highlight what makes your product unique and ensure
                accurate shipping details.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            defaultExpanded={true}
            sx={{
              mb: 2,
              border: "1px solid #E6E6E6",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                sx={{
                  color: "#333",
                  fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                  fontWeight: 500,
                }}
              >
                Can I leave reviews for vendors?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Absolutely! Your feedback helps other buyers make informed
                decisions and supports vendors in improving their offerings.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            defaultExpanded={true}
            sx={{
              mb: 2,
              border: "1px solid #E6E6E6",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                sx={{
                  color: "#333",
                  fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                  fontWeight: 500,
                }}
              >
                Is there a way to connect directly with a vendor?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Yes, Mamaket allows you to message vendors directly through the
                platform to ask questions or discuss specific needs.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            defaultExpanded={true}
            sx={{
              mb: 2,
              border: "1px solid #E6E6E6",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                sx={{
                  color: "#333",
                  fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                  fontWeight: 500,
                }}
              >
                How does Mamaket handle shipping for purchased items?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Vendors handle shipping, and we partner with reliable services
                to ensure timely and safe delivery of your orders. Tracking
                details will be provided.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            defaultExpanded={true}
            sx={{
              mb: 2,
              border: "1px solid #E6E6E6",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                sx={{
                  color: "#333",
                  fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                  fontWeight: 500,
                }}
              >
                Are there discounts or promotions for frequent buyers?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Yes, we offer discounts, promotions, and loyalty rewards for our
                frequent shoppers. Keep an eye on our website and emails for
                updates.
              </Typography>
            </AccordionDetails>
          </Accordion>
        </Box>
      </Box>
    </Box>
  );
};

export default HelpCenter;
